import Form from "antd/lib/form";
import { HTMLAttributes } from "react";
import { AriaTextFieldOptions } from "react-aria";
import { UseControllerProps } from "react-hook-form";

import { BaseFieldProps, useFieldInfo } from "@sol/forms/fields";
import { useFormSchema } from "@sol/forms/useFormSchema";
import { Input } from "@sol/uikit/data-entry/Input/Input";
type Props = {
    className?: string;
    containerAttributes?: HTMLAttributes<HTMLDivElement>;
} & BaseFieldProps &
    UseControllerProps &
    AriaTextFieldOptions<"input">;

const TextField = ({ className, containerAttributes, ...props }: Props) => {
    const schema = useFormSchema();

    const fieldInfo = useFieldInfo(props, schema);

    const { label, hint, isRequired, errorMessage, max, placeholder, value = "", onBlur, onChange } = fieldInfo;

    return (
        <Form.Item
            className={className}
            label={label}
            extra={hint}
            required={isRequired}
            validateStatus={errorMessage ? "error" : undefined}
            help={errorMessage}
            layout="vertical"
        >
            <Input
                status={errorMessage ? "error" : undefined}
                aria-invalid={`${!!errorMessage}`}
                max={max}
                placeholder={placeholder}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
            />
        </Form.Item>
    );
};

export default TextField;
